import { render, staticRenderFns } from "./TrainActivity.vue?vue&type=template&id=13766222"
import script from "./TrainActivity.vue?vue&type=script&lang=js"
export * from "./TrainActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports